module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || "laz2ulca",
    dataset: process.env.SANITY_DATASET || "production"
  }
};
